import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CPParticipantActivityTimelineWrapper = styled.div`
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100% !important;
  }

  .activity-timeline {
    padding-top: 16px;
    background-color: ${COLORS.cirrus_white};

    .MuiGrid2-container {
      padding: 0px;
      margin-top: 0;
    }

    .date-picker {
      padding-right: 16px;
    }

    .go-btn-grid {
      .btn-primary {
        height: 48px;
      }
    }

    .modify-next-contact-date-container {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .MuiPickersTextField-root,
    .MuiPickersInputBase-root {
      width: 100% !important;
    }

    .next-contact-date-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-start;
      padding-bottom: 16px;
      padding-left: 16px;
      padding-right: 16px;
      border-bottom: 1px solid ${COLORS.cirrus_black4};

      ${responsive.TABLET_PORTRAIT`
          flex-direction: column; 
          align-items: flex-start; 
        `}

      .MuiPickersTextField-root,
      .MuiPickersInputBase-root {
        width: 100% !important;
      }
    }

    .filter-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-start;
      padding: 16px;
      border-bottom: 1px solid ${COLORS.cirrus_black4};

      ${responsive.TABLET_PORTRAIT`
        justify-content: space-between;
      `}

      ${responsive.MOBILE`
        padding: 16px 8px;
      `}

      .add-activity-wrapper {
        margin-left: auto; /* Align this to the right */

        ${responsive.MOBILE`
          width: 100%;
          margin-right: 0;
          .btn-secondary {
            width: 100%;
          }
        `}
      }
      ${responsive.TABLET_PORTRAIT`
          .modality {
            margin-left: 0;
            margin-top: 10px;
          }
          .add-activity-wrapper {
            margin-left: 0;
            margin-top: 10px;
          }
        `}

      ${responsive.MOBILE`
          .modality {
          width: 100%;
            .mui-select {
              width: 100%;
            }
          }
        `}
    }

    .duration-picker-wrapper {
      background: ${COLORS.cirrus_black2};
      padding: 16px;

      .go-btn-grid {
        display: flex;

        ${responsive.MOBILE`
          margin-top: 8px;
        `}

        .MuiButtonBase-root {
          margin-top: auto;
        }
      }
    }
  }
`;
